import fetch from 'app/utils/requests/fetch';
import type { TokenPayload } from 'app/services/auth';
import urlQueryParams from 'app/utils/requests/query-params';

type CreateCognitoServiceArgs = {
  url: string;
};

const createCognitoService = ({ url }: CreateCognitoServiceArgs) => {
  if (!url) {
    throw new Error('No URL to Cognito API service supplied');
  }

  const exchangeCognitoToken = async (token: string): Promise<TokenPayload> => {
    const params = urlQueryParams({
      token,
    });

    const { body } = await fetch(url, {
      body: params,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
    });

    return body as TokenPayload;
  };

  return {
    exchangeCognitoToken,
  };
};

export type CognitoService = ReturnType<typeof createCognitoService>;

export default createCognitoService;
